import api from '../services/config/api';

export interface Lawyer {
  id: number;
  name: string;
}

export const getLawyers = () => api.get<Lawyer[]>('/lawyer');

export const listLawyer = (query?: string) => api.get(`lawyer/filter?${query || ''}`);

export const saveLawyer = async (data: { id: number; name: string; status: boolean }) =>
  await api.post('/lawyer', data);

export const activeOrInactiveLawyer = async (data: {
  id: number;
  name: string;
  status: boolean;
}) => {
  return await api.put(`/lawyer/${data.id}`, data);
};
